<template>
  <q-dialog v-model="opened">
      <draggable v-model="items" :options="{animation:150}" :no-transition-on-drag="true" @start="drag=true" @end="drag=false" v-if="itemId != null">
        <transition-group :name="!drag? 'list-complete' : null" :css="true">
          <q-card v-for="element in items" :key="element.id" class="q-ma-sm list-complete-item" :color="(element.id === itemId) ? 'primary' : ''">
            <q-card-main>{{element.name}}</q-card-main>
          </q-card>
        </transition-group>
      </draggable>
  </q-dialog>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  // name: 'ComponentName',
  components: {
    draggable
  },
  data () {
    return {}
  },
  computed: {
    opened: {
      get () { return this.$store.state.ui.reorderModalOpen },
      set (v) { this.$store.commit('setReorderModalOpen', v) }
    },
    itemId () { return this.$store.state.ui.reorderModalItemId },
    itemParentId () { return this.$store.getters.getParents(this.itemId)[0] },
    items: {
      get () { return this.$store.getters.getItemChildren(this.itemParentId) },
      set (v) {
        if (this.itemParentId == null) {
          this.$store.dispatch('updateRootChildren', this.$_.map(v, 'id'))
        } else {
          this.$store.dispatch('updateItemChildren', { noteId: this.itemParentId, newChildIds: this.$_.map(v, 'id') })
        }
      }
    }
  },
  mounted () {
    // let items = [1, 2, 3, 4, 5, 6]
    // items.forEach(i => {
    //   this.myArray.push({
    //     name: i,
    //     id: i
    //   })
    // })
  }
}
</script>

<style>
</style>
